import React from 'react'

export const Home = () => (
  <div className="container">
    <p>You probably shouldn't be here</p>
  </div>
)